import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAgahSplashLogo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={141} height={56} fill='none' {...props}>
    <g fill='#fff' clipPath='url(#AgahSplashLogo_svg__a)'>
      <path d='M8.516 21.5a13.05 13.05 0 0 1 3.888-9.008 13 13 0 0 1 9.057-3.74 13 13 0 0 1 9.093 3.65 13.05 13.05 0 0 1 3.977 8.97h8.456a21.52 21.52 0 0 0-4.285-12.75 21.45 21.45 0 0 0-11.01-7.7 21.4 21.4 0 0 0-13.422.37A21.46 21.46 0 0 0 3.696 9.582 21.52 21.52 0 0 0 4.93 35.108a21.44 21.44 0 0 0 11.323 7.23 21.4 21.4 0 0 0 13.394-.931l-3.183-7.845a12.98 12.98 0 0 1-12.159-1.253 13 13 0 0 1-4.22-4.685A13.05 13.05 0 0 1 8.555 21.5' />
      <path d='m21.519 21.371 4.974 12.191a13 13 0 0 0 5.866-4.8 13.05 13.05 0 0 0 2.202-7.261v-.12H21.519z' />
      <path
        fillRule='evenodd'
        d='M81.03 34.559v8.543h29.398a.546.546 0 0 1 .547.548v3.827H77.289a.535.535 0 0 1-.536-.538l-.05-21.222V21.73h-9.55v8.672l1.064.997v20.484c0 1.095.434 2.144 1.206 2.918a4.12 4.12 0 0 0 2.912 1.209h47.196V38.706a4.12 4.12 0 0 0-1.203-2.935 4.1 4.1 0 0 0-2.925-1.212H93.854l21.807-12.829h-12.724zM46.868 38.985h8.565v7.974a.55.55 0 0 1-.547.548h-7.959v-8.542h-8.575V56.04H59.84a4.1 4.1 0 0 0 3.8-2.548c.205-.501.31-1.037.309-1.579v-21.58H46.868z'
        clipRule='evenodd'
      />
      <path
        fillRule='evenodd'
        d='M115.233 33.433h8.546v-3.16h12.933a4.1 4.1 0 0 0 2.913-1.209 4.13 4.13 0 0 0 1.206-2.918V21.74h-21.519a4.1 4.1 0 0 0-3.777 2.592 4.1 4.1 0 0 0-.292 1.585zM123.789 56.08h4.437a4.11 4.11 0 0 0 2.893-1.22 4.13 4.13 0 0 0 1.196-2.907V34.579h-8.526zM81.03 28.339v4.924L100.868 21.7h-8.437z'
        clipRule='evenodd'
      />
    </g>
    <defs>
      <clipPath id='AgahSplashLogo_svg__a'>
        <path fill='#fff' d='M0 0h141v56H0z' />
      </clipPath>
    </defs>
  </svg>
);
export default SvgAgahSplashLogo;
